import type { api } from "~/utils/api";
import { invalidateTaskSearch } from "./invalidateTaskSearch";

type ApiUtils = ReturnType<typeof api.useUtils>;
type InvalidateFilters = NonNullable<Parameters<typeof invalidateTaskSearch>[1]>;

// Readiness is server-derived, so after a status/dueDate change every surface that renders a task's
// readiness must refetch — the client cannot recompute it. Enumerated in one place so a call site
// can't quietly omit a surface (e.g. the Schedule Work milestone table) and leave it stale.
export function invalidateTaskReadinessQueries(
  utils: ApiUtils,
  scope?: { workSiteId: number },
  filters?: InvalidateFilters,
): Promise<unknown> {
  return Promise.all([
    utils.task.getTaskById.invalidate(undefined, filters),
    utils.task.getByProjectId.invalidate(undefined, filters),
    utils.task.getTodaysActions.invalidate(undefined, filters),
    utils.task.getContractorPlate.invalidate(undefined, filters),
    utils.project.getProjectsForMilestoneTable.invalidate(undefined, filters),
    utils.project.getProjectCountAndSummaryForMilestoneTable.invalidate(undefined, filters),
    utils.escalation.getDetailForHub.invalidate(undefined, filters),
    utils.favorites.listMine.invalidate(undefined, filters),
    scope === undefined
      ? utils.workSite.getWorksiteDetail.invalidate(undefined, filters)
      : utils.workSite.getWorksiteDetail.invalidate({ workSiteId: scope.workSiteId }, filters),
    scope === undefined
      ? utils.workSite.getWorksiteDailyActionSummary.invalidate(undefined, filters)
      : utils.workSite.getWorksiteDailyActionSummary.invalidate({ workSiteId: scope.workSiteId }, filters),
    invalidateTaskSearch(utils.task, filters),
  ]);
}
